exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a[data-v-760c3de7]{color:inherit;text-decoration:none;cursor:pointer!important;pointer-events:all;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}p[data-v-760c3de7]{margin-bottom:12px}ol[data-v-760c3de7]{list-style:inside}.website[data-v-760c3de7]{height:100%;width:100%;display:block;z-index:0}.website-flex[data-v-760c3de7]{display:flex;align-items:baseline;justify-content:flex-start;width:100%;max-width:1400px;margin:0 auto}@media (max-width:440px){.website-flex[data-v-760c3de7]{flex-flow:column}}.website-dynamicContent[data-v-760c3de7]{display:flex;flex-flow:column;position:relative;width:100%;height:100%;margin-top:70px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?minimize!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-760c3de7","scoped":true,"hasInlineConfig":false}!../node_modules/sass-loader/lib/loader.js?indentedSyntax!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/combinedBlocks/Website.vue
// module id = 357
// module chunks = 0